import { preprocessStanleyTargetQueryForApply } from 'src/operations/query';

import {
  StanleyMembershipTargetContext,
} from './hooks/use-stanley-query-membership-size/buildStanleyMembershipBody';
import { StanleyQuerySuggestion } from './types';

/** Audience payload for {@link prepareNewAudience} before opening ShareAudience. */
export const buildStanleyAudienceShareData = (
  dataSource: string,
  suggestion: StanleyQuerySuggestion,
  target?: StanleyMembershipTargetContext | null
) => {
  const rawTargetQuery = suggestion.query_json?.target_query;
  if (!rawTargetQuery) {
    return null;
  }

  const prepared = preprocessStanleyTargetQueryForApply(rawTargetQuery);
  if (!prepared) {
    return null;
  }

  const queryJson = suggestion.query_json;
  const baseQuery = queryJson?.base_query ??
    target?.base_query ?? {
      whole_population: true,
      query_block: null,
    };

  const queryType =
    queryJson?.query_type ?? target?.query_type ?? 'interest';

  const shareData: Record<string, unknown> = {
    query_type: queryType,
    label: suggestion.title,
    target_label: suggestion.title,
    target_query: prepared,
    base_query: baseQuery,
    target_membership_id: target?.target_membership_id ?? null,
    data_source: queryJson?.data_source ?? target?.data_source ?? dataSource,
  };

  if (queryType !== 'interest') {
    return {
      ...shareData,
      audience_timeframe: target?.audience_timeframe,
      results_timeframe: target?.results_timeframe ?? 52,
    };
  }

  return shareData;
};
